import React from 'react';
import './EmbeddingStatusIndicator.css';

function EmbeddingStatusIndicator({ status, error, ageText = null, className = '' }) {
  // Determine the display text and icon based on status
  const getStatusConfig = (status) => {
    switch (status) {
      case 'loading':
        return {
          text: 'Loading',
          icon: 'fas fa-spinner fa-spin',
          // Reuse processing style so we don't need new CSS
          className: 'status-processing'
        };
      case 'created':
        return {
          text: 'Pending',
          icon: 'fas fa-clock',
          className: 'status-pending'
        };
      case 'processing':
        return {
          text: 'Processing',
          icon: 'fas fa-spinner fa-spin',
          className: 'status-processing'
        };
      case 'finished':
        return {
          text: 'Ready',
          icon: 'fas fa-check-circle',
          className: 'status-ready'
        };
      case 'stale':
        return {
          text: 'Needs Re-embed',
          icon: 'fas fa-triangle-exclamation',
          className: 'status-stale'
        };
      case 'errored':
        return {
          text: 'Error',
          icon: 'fas fa-exclamation-triangle',
          className: 'status-error'
        };
      case 'canceled':
        return {
          text: 'Canceled',
          icon: 'fas fa-times-circle',
          className: 'status-canceled'
        };
      case 'none':
      case null:
      case undefined:
      default:
        return {
          text: 'No Embeddings',
          icon: 'fas fa-minus-circle',
          className: 'status-none'
        };
    }
  };

  const config = getStatusConfig(status);

  return (
    <div className={`embedding-status-indicator ${config.className} ${className}`}>
      <i className={config.icon}></i>
      <span className="status-text">
        {config.text}
        {status === 'finished' && ageText ? ` (${ageText})` : ''}
        {status === 'stale' && ageText ? ` — last embed ${ageText}` : ''}
      </span>
      {status === 'errored' && error && (
        <span className="error-details" title={error}>
          <i className="fas fa-info-circle" aria-hidden />
          <span className="error-details-text">{error}</span>
        </span>
      )}
    </div>
  );
}

export default EmbeddingStatusIndicator;